import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useReminder } from "../../hooks/useReminder";
import { useChannelsService } from "../../hooks/useChannelsService";

export const ReminderNotification = () => {
    const { closeReminder, isVisible, reminder } = useReminder();
    const _channels = useChannelsService();
    const channel = _channels.channels.find(ch => ch.ch_id === reminder?.channelId);
    return (
        <div className={`rounded-md bg-neutral-50 p-4 fixed top-14 right-8 w-full max-w-96 z-50 animate-opacityEaseIn transition-all duration-500  ${isVisible ? "translate-x-0 opacity-100" : "translate-x-[150%] opacity-0"}`}>
            <div className="flex">
                <div className="shrink-0">
                    <InformationCircleIcon aria-hidden="true" className="size-6 text-neutral-900" />
                </div>
                <div className="ml-3 w-full">
                    <h3 className="text-sm font-medium text-neutral-700 line-clamp-2 text-ellipsis ">{reminder?.title ?? ""}</h3>
                    <div className="mt-2 text-sm text-neutral-700">
                        <p>Transmisja wkrótce się rozpocznie. Oglądaj na dekoderze na kanale {channel?.name ?? ""} (pozycja {channel?.position}).</p>
                    </div>
                    <div className="mt-5">
                        <div className="-my-1.5 flex space-x-3">
                            {/* <Button size={ButtonSize.SMALL} variant={ButtonVariant.PRIMARY} className="border-0 ring-offset-neutral-50 py-1.5 font-medium focus:ring-offset-neutral-50 focus:ring-[#008DD2]"> Oglądaj</Button> */}
                            {channel?.enabled &&
                                <button
                                    type="button"
                                    className="rounded-full border bg-[#008DD2] px-5 py-1.5 text-sm font-medium  text-neutral-50 hover:bg-[#007CC1] focus:outline-none focus:ring-2 focus:ring-[#008DD2] focus:ring-offset-2 focus:ring-offset-neutral-50 transition-colors"
                                >
                                    Oglądaj
                                </button>
                            }
                            <button
                                type="button"
                                className="border rounded-full bg-neutral-50 px-5 py-1.5 text-sm font-medium text-neutral-700 hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-neutral-600 focus:ring-offset-2 focus:ring-offset-neutral-50 transition-colors"
                                onClick={closeReminder}
                            >
                                Odrzuć
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
